import AddIcons from '@/icons/AddIcons'
import DeleteOutlineIcons from '@/icons/DeleteOutlineIcons'
import React from 'react'
import { useFieldArray, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button, GridHookForm, IconButton, Typogaphy } from 'vnetwork-ui'

interface ExperienceTabProps {
    formControl: UseFormReturn<any>
    onNext?: () => void
    onPrevious?: () => void
}

const ExperienceTab: React.FC<ExperienceTabProps> = ({
    formControl,
    onNext,
    onPrevious,
}) => {
    const { t } = useTranslation()

    const { fields, append, remove } = useFieldArray({
        control: formControl.control,
        name: 'attendances',
    })

    return (
        <div className="">
            <GridHookForm
                subForm={true}
                actions={[]}
                formControl={formControl}
                className="grid grid-cols-1 md:grid-cols-2 gap-4"
                data={[
                    {
                        formItemProps: {
                            type: 'textfield',
                            name: 'employee_university',
                            placeholder: t('university'),
                            label: t('university'),
                        },
                        className: 'md:col-span-2',
                    },
                    {
                        formItemProps: {
                            type: 'textfield',
                            name: 'employee_major',
                            placeholder: t('major'),
                            label: t('major'),
                        },
                        className: 'md:col-span-2',
                    },
                    {
                        formItemProps: {
                            type: 'textarea',
                            name: 'employee_experience',
                            placeholder: t('experience'),
                            label: t('experience'),
                        },
                        className: 'md:col-span-2',
                    },
                ]}
            />
            <div className="bg-blue-50 rounded-md p-4">
                <div className="flex justify-between items-center mb-2">
                    <Typogaphy
                        size="medium"
                        className="font-semibold text-gray-900"
                    >
                        {t('attendances')} ({fields.length})
                    </Typogaphy>
                    <Button
                        variant="contained"
                        size="small"
                        startIcon={<AddIcons />}
                        onClick={() =>
                            append({
                                name: '',
                                description: '',
                            })
                        }
                        className="bg-primary hover:bg-primary/80"
                    >
                        {t('attendances.add')}
                    </Button>
                </div>

                {fields.length > 0 &&
                    fields.map((field, index) => (
                        <GridHookForm
                            key={field.id}
                            actions={[]}
                            className="grid grid-cols-1 md:grid-cols-12 gap-4"
                            data={[
                                {
                                    formItemProps: {
                                        type: 'textfield',
                                        name: `attendances.${index}.name`,
                                        label: t('attendances.name'),
                                        placeholder: t('attendances.name'),
                                    },
                                    className: 'md:col-span-3',
                                },
                                {
                                    formItemProps: {
                                        type: 'textfield',
                                        name: `attendances.${index}.description`,
                                        label: t('attendances.description'),
                                        placeholder: t(
                                            'attendances.description'
                                        ),
                                    },
                                    className: 'md:col-span-8',
                                },
                                {
                                    renderEditComponent: () => (
                                        <div className="flex justify-end">
                                            <IconButton
                                                size="small"
                                                onClick={() => remove(index)}
                                            >
                                                <DeleteOutlineIcons className="text-red-500" />
                                            </IconButton>
                                        </div>
                                    ),
                                    className: 'md:col-span-1',
                                },
                            ]}
                            subForm
                            formControl={formControl}
                        />
                    ))}
            </div>
            <GridHookForm
                subForm
                actions={[
                    {
                        title: t('employees.previous_step'),
                        type: 'button',
                        variant: 'outlined',
                        handler: () => {
                            formControl?.handleSubmit(onPrevious as any)()
                        },
                    },
                    {
                        title: t('employees.next_step'),
                        type: 'button',
                        variant: 'contained',
                        handler: () => {
                            formControl?.handleSubmit(onNext as any)()
                        },
                    },
                ]}
                data={[]}
                formControl={formControl}
                className="grid grid-cols-1 md:grid-cols-2 gap-4"
            />
        </div>
    )
}

export default ExperienceTab
